import { Stack } from '@mantine/core';
import CustomLoadingOverlay from '@/components/CustomLoadingOverlay.tsx';
import StepExecutionLog from '@/pages/Run/components/StepExecutionLogs/StepExecutionLog.tsx';
import { getRenderableStepExecutionLogs } from '@/pages/Run/components/StepExecutionLogs/renderableLogs.ts';
import { StepExecutionLogs } from '@/types/stepExecutions.ts';

type props = {
  logs: StepExecutionLogs | undefined;
  isPending: boolean;
};

const StepExecutionLogsRenderer = ({
  logs,
  isPending,
}: props) => {
  return (
    <>
      <Stack
        gap={'sm'}
        style={{ maxWidth: '100%', minWidth: 0, overflow: 'hidden', position: 'relative' }}
      >
        {/* Vertical line */}
        <div
          style={{
            position: 'absolute',
            left: '9px',
            top: '5px',
            bottom: '5px',
            width: '1px',
            backgroundColor: '#EAEAEA',
            zIndex: 0,
          }}
        />
        <CustomLoadingOverlay visible={isPending} />

        {getRenderableStepExecutionLogs(logs ?? []).map((log) => (
            <StepExecutionLog log={log} key={log.id} />
        ))}
      </Stack>
    </>
  );
};

export default StepExecutionLogsRenderer;
